import { render, staticRenderFns } from "./InvitationFormIndividual.vue?vue&type=template&id=396e4821&scoped=true"
import script from "./InvitationFormIndividual.vue?vue&type=script&lang=js"
export * from "./InvitationFormIndividual.vue?vue&type=script&lang=js"
import style0 from "./InvitationFormIndividual.vue?vue&type=style&index=0&id=396e4821&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396e4821",
  null
  
)

export default component.exports